// extracted by mini-css-extract-plugin
export var panel = "Dropdown-module--panel--d5039";